const quotationChat = {
  quotationChatNavLabel: "报价聊天", // translated
  quotationChatApprovalTitle: "报价聊天", // translated
  quotationChatAccountNotApprovedTitle: "账户未获批准", // translated
  quotationChatAccountNotApprovedDescription: "您的账户尚未获得批准。请联系客户经理了解更多信息。", // translated
  quotationChatViewAiChat: "查看AI聊天", // translated
  quotationRequestChatSessions: "聊天会话", // translated
  quotationRequestChatNoPastSessions: "没有历史会话", // translated
  quotationRequestChatNewChat: "新聊天", // translated
  quotationRequestChatCloseSidebar: "关闭侧边栏", // translated
  quotationRequestChatSessionFallback: "聊天会话", // translated
  quotationRequestChatDefaultSessionName: "新聊天会话", // translated
  quotationRequestChatTitle: "报价请求聊天", // translated
  quotationRequestChatResponseLanguageLabel: "回复语言", // translated
  quotationRequestChatOpenSidebar: "打开侧边栏", // translated
  quotationRequestChatRenameSession: "重命名会话", // translated
  quotationRequestChatDeleteSession: "离开会话", // translated
  quotationRequestChatToggleDarkMode: "转换模式", // translated
  quotationRequestChatSwitchToLightMode: "切换到浅色模式", // translated
  quotationRequestChatSwitchToDarkMode: "切换到深色模式", // translated
  quotationRequestChatEmptyStateHeading: "开始新的报价请求对话", // translated
  quotationRequestChatEmptyStateSubheading: "描述您的旅行需求，我将为您创建报价请求。", // translated
  quotationRequestChatMessagePlaceholderStart: "输入消息以开始对话...（Shift+Enter 换行）", // translated
  quotationRequestChatMessagePlaceholder: "输入您的消息...（Shift+Enter 换行）", // translated
  quotationRequestChatUploadFile: "上传文件", // translated
  quotationRequestChatUploadAttachment: "上传附件", // translated
  quotationRequestChatStopGenerating: "停止生成", // translated
  quotationRequestChatGenerateQuotation: "生成报价", // translated
  quotationRequestChatGenerateFinalQuotation: "生成最终报价", // translated
  quotationRequestChatFinalizeQuotationRequest: "完成报价请求", // translated
  quotationRequestChatHoldToRecord: "按住录制语音消息", // translated
  quotationRequestChatRecordingReleaseToSend: "正在录制，起草发送", // translated
  quotationRequestChatRecording: "正在录制...", // translated
  quotationRequestChatSelectSessionFirst: "请先选择一个聊天会话。", // translated
  quotationRequestChatCancelVoiceRecording: "取消语音录制", // translated
  quotationRequestChatListening: "正在进行...", // translated
  quotationRequestChatTranscribing: "正在转写...", // translated
  quotationRequestChatFileUploadedSuccess: "文件上传成功。", // translated
  quotationRequestChatFailedCreateSession: "创建聊天会话失败。请重试。", // translated
  quotationRequestChatFailedUploadFile: "文件上传失败。请重试。", // translated
  quotationRequestChatAnswerPendingBeforeMessage: "请先回答待处理的问题，然后再发送另一条消息。", // translated
  quotationRequestChatAnswerPendingBeforeFinalize: "请先回答待处理的问题，然后再完成报价请求。", // translated
  quotationRequestChatFavoriteMarked: "聊天会话已标记为收藏", // translated
  quotationRequestChatFavoriteUnmarked: "聊天会话已取消收藏", // translated
  quotationRequestChatFailedSetFavorite: "收藏失败", // translated
  quotationRequestChatFailedUnsetFavorite: "取消收藏失败", // translated
  quotationRequestChatRenamedSuccess: "聊天会话重命名成功。", // translated
  quotationRequestChatFailedRename: "重命名聊天会话失败。请重试。", // translated
  quotationRequestChatDeletedSuccess: "聊天会话删除成功。", // translated
  quotationRequestChatFailedDelete: "删除聊天会话失败。请重试。", // translated
  quotationRequestChatAttachmentDeletedSuccess: "附件删除成功。", // translated
  quotationRequestChatFailedDeleteAttachment: "删除附件失败。请重试。", // translated
  quotationRequestChatSubmittedSuccess: "报价请求提交成功！您的请求正在处理中。", // translated
  quotationRequestChatFailedSubmit: "提交报价请求失败", // translated
  quotationChatPdfDownloadedSuccess: "PDF下载成功！", // translated
  quotationChatFailedGeneratePdf: "生成PDF失败", // translated
  quotationRequestChatSubagentRequired: "提交报价请求前，请选择子代理用户。", // translated
  quotationRequestChatAppUserLoading: "您的CRM应用用户数据仍在加载中。请稍后再试。", // translated
  quotationRequestChatAppUserMismatch: "您的 CRM 应用用户数据与此聊天会话不匹配。", // translated
  quotationRequestChatRenameTitle: "重命名聊天会话", // translated
  quotationRequestChatSessionName: "会话名称", // translated
  quotationRequestChatEnterSessionName: "输入会话名称", // translated
  quotationRequestChatSaving: "正在保存...", // translated
  quotationRequestChatSave: "保存", // translated
  quotationRequestChatDeleteTitle: "删除聊天会话", // translated
  quotationRequestChatDeleteConfirm: "确定要删除此聊天会话吗？", // translated
  quotationRequestChatDeleteCannotUndo: "此操作无法撤销。", // translated
  quotationRequestChatDeleting: "正在删除...", // translated
  quotationRequestChatDelete: "删除", // translated
  quotationRequestChatAttachmentsTitle: "报价请求聊天附件", // translated
  quotationRequestChatLoadingAttachments: "正在加载附件...", // translated
  quotationRequestChatNoAttachments: "未找到附件", // translated
  quotationRequestChatDeleteAttachment: "删除附件", // translated
  quotationRequestChatUploadingAttachment: "正在上传附件...", // translated
  quotationRequestChatUploadingAttachmentWait: "请稍候，您的文件正在上传。", // translated
  quotationRequestChatAnswerPendingQuestions: "回答待处理问题", // translated
  quotationRequestChatProposeOwnAnswer: "提出我自己的答案", // translated
  quotationRequestChatTypeOwnAnswerPlaceholder: "输入您自己的答案...", // translated
  quotationRequestChatAnsweredOfTotal: "已回答 {{answered}} / {{total}}", // translated
  quotationRequestChatReadyToSubmit: "可以提交", // translated
  quotationRequestChatSubmitAll: "全部提交", // translated
  quotationRequestChatRespondToOneQuestion: "回答 {{count}} 个问题", // translated
  quotationRequestChatRespondToManyQuestions: "回答 {{count}} 个问题", // translated
  quotationRequestChatFinalizeTitle: "完成报价请求", // translated
  quotationRequestChatLoadingSessionData: "正在加载会话数据...", // translated
  quotationRequestChatErrorLoadingSession: "加载会话数据错误。请重试。", // translated
  quotationRequestChatQuotationTitle: "报价标题", // translated
  quotationRequestChatExtraComments: "附加评论", // translated
  quotationRequestChatSubmitting: "正在提交...", // translated
  quotationRequestChatSubmit: "提交", // translated
  quotationRequestChatSubmittingOverlayTitle: "正在提交报价请求...", // translated
  quotationRequestChatSubmittingOverlayDescription: "请稍候，您的报价请求正在提交。", // translated
  quotationRequestChatSelectSubagent: "选择子代理", // translated
  quotationRequestChatSearchSubagents: "搜索子代理...", // translated
  quotationRequestChatLoadingSubagents: "正在加载子代理...", // translated
  quotationRequestChatNoSubagentsFound: "未找到子代理", // translated
  quotationRequestChatNoSubagentsAvailable: "没有可用的子代理", // translated
  quotationRequestChatSelectedSubagent: "已选择：{{标签}}", // translated
  quotationRequestChatSubagentUsers: "子代理用户", // translated
  quotationRequestChatSearchUsers: "搜索用户...", // translated
  quotationRequestChatNoUsersFound: "未找到用户", // translated
  quotationRequestChatNoUsersAvailable: "没有可用的用户", // translated
  quotationChatDownloadSummaryTitle: "下载您的报价摘要", // translated
  quotationChatDownloadSummaryDescription:
    "在下方填写您的详细信息，以个性化生成的行程报价PDF摘要。PDF将包含所有行程详情、目的地、交通信息以及逐日行程安排。", // translated
  quotationChatCustomerTitle: "称谓", // translated
  quotationChatSelectTitle: "选择称谓", // translated
  quotationChatHonorificMr: "先生", // translated
  quotationChatHonorificMrs: "夫人", // translated
  quotationChatHonorificMs: "女士", // translated
  quotationChatHonorificDr: "博士", // translated
  quotationChatHonorificProf: "教授", // translated
  quotationChatCustomerPhone: "电话", // translated
  quotationChatCustomerCompany: "公司", // translated
  quotationChatCustomerMessage: "留言", // translated
  quotationChatCustomerCountry: "国家", // translated
  quotationChatGenerating: "正在生成...", // translated
  quotationChatDownloadPdf: "下载PDF", // translated
  quotationChatTripSummary: "行程摘要", // translated
  quotationChatDownloadAsPdf: "下载为PDF", // translated
  quotationChatNoTripSummary: "此会话没有可用的行程摘要。", // translated
  quotationRequestChatThinking: "正在思考...", // translated
  quotationRequestChatSources: "来源", // translated
  quotationRequestChatSearchingWebFor: "正在搜索网络：“{{query}}”...", // translated
  quotationRequestChatServicesByTourOperator: "由车站提供的服务", // translated
  quotationRequestChatServicesByCustomer: "由客户自行处理的服务", // translated
  quotationRequestChatReadyNotice: "您现在可以点击右侧按钮来请求生成报价。", // translated
  quotationRequestChatGenerateFinalQuotationAria: "生成最终报价", // translated
  quotationRequestChatMaybeYouWantToAsk: "您可能想问：", // translated
  quotationRequestChatClickToSendSuggestion: "点击此发送消息", // translated
  quotationRequestChatAddToFavorites: "添加到收藏", // translated
  quotationRequestChatRemoveFromFavorites: "从收藏中删除", // translated
  quotationRequestChatSubmitted: "已提交", // translated
  quotationRequestChatQuotationRequest: "报价请求：{{reference}}", // translated
  quotationRequestChatQuotationTooltipTitle: "{{标题}}", // translated
  quotationRequestChatQuotationTooltipStatus: " - 状态：{{status}}", // translated
  quotationChatLoading: "正在加载...", // translated
  quotationChatSessionNotFound: "未找到此报价的聊天会话", // translated
  quotationChatMemberSessionNotFound: "未您找到账户的成员会话", // translated
  quotationChatUnableToConnect: "无法连接聊天", // translated
  quotationChatConnecting: "正在连接...", // translated
  quotationChatTypeYourMessage: "输入您的消息...", // translated
  quotationChatConnected: "已连接", // translated
  quotationChatConnectingStatus: "正在连接...", // translated
  quotationChatDisconnected: "已断开连接", // translated
};

export default quotationChat;
